import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ReportStyledModal,CalendarHeader,Border, ConfirmPlanModalBody} from './styles';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from '../ReportsV2/styles';
import { fetchApi } from '../../utils/methods';
import { toast } from 'react-toastify';
import { GetRewardReport,GetCompanyAdminRewardPeriods, GetEngagementReport } from '../../redux/constants/apiConstants';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';
import { StyledLabel } from '../CreateEvent/style';
// import { t } from 'i18next';
// import { RadioGroup, RadioLabel } from '../../EditWellnessJourney/styles';
// import RadioButtonNew from '../../ContentV2/CustomRadioButtonNew';
import { AdminCloseIcon } from '../../utils/icons';
import dayjs from 'dayjs';
import CSVList from '../AttendeesModal/CSVList';

const ReportsArray = [{label:"Rewards",value:'rewards'},{label:"Engagement",value:'engagement'}];

const headers = [
  { label: "USER ID", key: "user_id" },
  { label: "FIRST NAME", key: "first_name" },
  { label: "LAST NAME", key: "last_name" },
  { label: "EMAIL", key: "email" },
  { label: "DEPARTMENT", key: "department" },
  { label: "LOCATION", key: "location" },
  { label: "POINTS EARNED TILL NOW", key: "points_earned_till_now" },
  { label: "CURRENT LEVEL", key: "current_level" },
  { label: "CHALLENGE POINTS", key: "challenge_points" },
  { label: "EVENT POINTS", key: "event_points" },
  { label: "FITNESS POINTS", key: "fitness_points" },
  { label: "HEALTH HUB POINTS", key: "health_hub_points" },
  { label: "RECOGNITION POINTS", key: "recognition_points" },
  { label: "SURVEY POINTS", key: "survey_points" },
  { label: "WELLNESS HUB POINTS", key: "wellness_hub_points" }
];


const ReportModal = ({
  show,
  icon,
  title,
  onCancel,
  modalWidth = "500px",
  modalHeight,
  companyInfo,
  onClose
  //   history,
}) =>{

  const [loading, setLoading] = useState(false);
  const [selectedBadge, setSelectedBadge]  = useState();
  const [printCSV, setPrintCSV] = useState(false);
  const [csvData, setCsvData] = useState([]);


  const[badgeDropdownOpen,setBadgeDropdownOpen] = useState(false);
  // const[selectedDuration, setSelectedDuration] = useState('year');

  const[monthDropdownOpen,setMonthDropdownOpen] = useState(false);
  const [rewardPeriodData, setRewardPeriodData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(dayjs().format("YYYY"));

  useEffect(()=>{
    fetchCompanyRewardsDetailsYearwise()
  },[]);

  const selectYearData = (value) => {
    setSelectedYear(value)
    // fetchTopCardsAndGraph(value)
  }

  const fetchCompanyRewardsDetailsYearwise = async() =>{
    setLoading(true);
    try {

      const companyRewardsData = await fetchApi(GetCompanyAdminRewardPeriods+'?company_id='+ companyInfo.id , "GET");
      if(companyRewardsData.status === 'success'){
        setRewardPeriodData(companyRewardsData?.data?.periods);
        setSelectedYear(companyRewardsData?.data?.periods?.[0])
      }else{
        toast.error(companyRewardsData.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }

  const generateOrderedHeaders = (obj = {}) => {
    window.console.log("hii",obj)
    return Object.keys(obj).map((key) => ({
      key,
      label: key.replace(/_/g, " ").toUpperCase()
    }));
  };

  const engagementHeaders = useMemo(() => {
    if (selectedBadge?.value === "engagement") {
      return generateOrderedHeaders(csvData?.[0]);
    }
    return [];
  }, [csvData, selectedBadge]);

  const getHeaders = () => {
    if (selectedBadge?.value === "engagement") return engagementHeaders;
    if (selectedBadge?.value === "rewards") return headers;
    return headers;
  };

  useEffect(() => {
    if (csvData?.length > 0) {
      setPrintCSV(true);
    }
  }, [csvData]);


  const fetchRewardReport = async() =>{
    setLoading(true);
    try {
      const companyRewardsData = await fetchApi(`${selectedBadge?.value === "engagement" ? GetEngagementReport : GetRewardReport}?company_id=${companyInfo?.id}&reward_period_id=${selectedYear?.reward_period_id}`);
      if(companyRewardsData?.status === 'success'){
        setCsvData(companyRewardsData?.data);
        // setPrintCSV(true);
        // getHeaders()
        // onCancel();
      }else{
        toast.error(companyRewardsData?.data?.message);
      }
    } catch (error) {
      toast.error(error);
      
    }finally{
      setLoading(false);
    }
  }


  const onBadgeChange = (item)=>{
    window.console.log("item",item);
    setSelectedBadge(item);
  }


  

  const SelectPointTierLevels = () => {
    window.console.log("hihi");
    
    return (
      <>

        {/* <div className="formBody" style={{width:'100%'}}>
          <StyledLabel margin='20px' marginb='12px' style={{float:'unset'}}>{t("Select Date Range")}?{<span>*</span>}</StyledLabel>
          <RadioGroup>
            <RadioLabel onClick={() => setSelectedDuration('year')}>
              <RadioButtonNew
                isChecked={selectedDuration === 'year'}
                handler={() => setSelectedDuration(1)}
                value={"yesr"}
                background={"#85c0ea"}
              />
              {t("This Year")}
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(2)}>
              <RadioButtonNew
                isChecked={selectedDuration === 2}
                handler={() => setSelectedDuration(2)}
                // value={'2'}
                background={"#85c0ea"}
              />
              {t("This Month")}
            </RadioLabel>
  
            <RadioLabel onClick={() => setSelectedDuration(3)}>
              <RadioButtonNew
                isChecked={selectedDuration === 3}
                handler={() => setSelectedDuration(3)}
                // value={'3'}
                background={"#85c0ea"}
              />
              {t("This Quarter")}
            </RadioLabel>
          </RadioGroup>
        </div> */}


        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px", margin: "20px 0 0 0" }}
          // dropdownButtonPadding={"0px 35px 0px 12px"}
          dropdownStyle={{ top: "95px" }}
          labelText={"Reward Period"}
          isRequired={true}
          dropdownOpen={monthDropdownOpen}
          placeholder={"Year"}
          title={
            dayjs(selectedYear?.reward_start_date).format("MMM YYYY") + " - " + dayjs(selectedYear?.reward_end_date).format("MMM YYYY")
          }
          id="dropdown-recurring"
          onClick={() => setMonthDropdownOpen(!monthDropdownOpen)}
          data={rewardPeriodData}
          active={selectedYear}
          onSelectParameter={["year", "firstDate", "month"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={0}
          labelMargin={"0px"}
          onSelect={selectYearData}
          dropIcon={true}
          // isManagerMargin={'0px'}
          top={'8px'}
          showDateRange={true}
          dateRangeKeys={{
            start: "reward_start_date",
            end: "reward_end_date"
          }}
        />

        <CommonDropdown
          tileContainerStyle={{ width: "100%", padding:"0px 0px 0px 0px", margin: "20px 0 0 0" }}
          dropdownStyle={{ top: "95px" }}
          labelText={"Select Report"}
          isRequired={true}
          dropdownOpen={badgeDropdownOpen}
          placeholder={"Select Report"}
          title={
            selectedBadge?.label
          }
          id="dropdown-recurring"
          onClick={() => setBadgeDropdownOpen(!badgeDropdownOpen)}
          data={ReportsArray}
          active={selectedBadge?.badge}
          onSelectParameter={["label", "value"]}
          // valueString={"Points"}
          itemValue={true}
          valueIndex={0}
          labelMargin={"0px"}
          onSelect={onBadgeChange}
          dropIcon={true}
          optionsHeight={'100px'}
        />


        
      </>
    );
  };
      
    
  return(
    <ReportStyledModal show={show} width={modalWidth} height={modalHeight}>
      <div className="modal-content-padding">
        <CalendarHeader style={{marginBottom:'0px'}}>
          <div className="left-content">
            {icon ? <div className="icon">{icon}</div> : null}
            <div>{title}</div>
          </div>
          <div className="close-icon" onClick={()=>onClose ? onClose() :onCancel()}>
            {AdminCloseIcon()}
          </div>
        </CalendarHeader>
        <StyledLabel margin={'8px'} marginb={'20px'} style={{float:'unset'}}>Download a CSV of rewards activity.</StyledLabel>
        <Border/>
  
      </div>

      <ConfirmPlanModalBody>

        {SelectPointTierLevels()}
      </ConfirmPlanModalBody>

      <Border margin={'20px 0px'}/>
  
      <div className='footer' >
        <CommonButtonPopup height="48px" width="200px" disabled={!selectedYear || !selectedBadge || loading} onClick={() => fetchRewardReport()}>
        Download Report
        </CommonButtonPopup>
  
      </div>
      {printCSV && (
        <CSVList
          Title={`${selectedBadge?.label}_Report_${dayjs(selectedYear?.reward_start_date).format("MMM YYYY") + " - " + dayjs(selectedYear?.reward_end_date).format("MMM YYYY")}`}
          data={csvData}
          headers={getHeaders()}
          removeCSVData={() => {setPrintCSV(false);setCsvData([])}}
        />
      )}
    </ReportStyledModal>
  )};


ReportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title:PropTypes.string, 
  onCancel: PropTypes.func.isRequired,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  icon: PropTypes.node.isRequired, 
  onClose:PropTypes.func,
  history:PropTypes.object,
  companyInfo:PropTypes.object
};

export default withRouter((ReportModal));
  
